/**
 * 导航返回行为 Context
 * 用于在页面组件和 AppNav 之间共享返回按钮的行为配置
 */

import React, { createContext, useContext, useState, useCallback } from "react";

export interface BackButtonConfig {
  /** 是否显示返回按钮 */
  enabled: boolean;
  /** 返回目标路径（如果指定）或使用自定义回调 */
  targetPath?: string;
  /** 自定义返回行为 */
  onBack?: () => void;
}

interface NavBackContextValue {
  config: BackButtonConfig;
  setConfig: (config: BackButtonConfig) => void;
  resetConfig: () => void;
}

const defaultConfig: BackButtonConfig = {
  enabled: false,
};

const NavBackContext = createContext<NavBackContextValue | null>(null);

export function NavBackProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfigState] = useState<BackButtonConfig>(defaultConfig);

  const setConfig = useCallback((newConfig: BackButtonConfig) => {
    setConfigState(newConfig);
  }, []);

  const resetConfig = useCallback(() => {
    setConfigState(defaultConfig);
  }, []);

  return (
    <NavBackContext.Provider value={{ config, setConfig, resetConfig }}>
      {children}
    </NavBackContext.Provider>
  );
}

export function useNavBack(): NavBackContextValue {
  const context = useContext(NavBackContext);
  if (!context) {
    // 返回默认值，不抛出错误，以支持未包裹 Provider 的场景
    return {
      config: defaultConfig,
      setConfig: () => {},
      resetConfig: () => {},
    };
  }
  return context;
}
